import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Play, ExternalLink, Check } from "lucide-react";
import { TIER_LABEL } from "../lib/tiers";
import { mediaUrl } from "../lib/api";

export default function ContentTile({ item, completed, onOpen, onToggle }) {
  const navigate = useNavigate();
  const locked = !item.unlocked;
  const isVideo = item.type === "video";

  return (
    <div data-testid={`content-tile-${item.id}`}
      className="card-surface overflow-hidden group flex flex-col">
      <div className="relative aspect-video overflow-hidden bg-brand-cream2">
        <img src={mediaUrl(item.thumbnail)} alt={item.title} loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${locked ? "blur-md scale-105" : ""}`} />
        {locked ? (
          <div className="absolute inset-0 bg-black/45 flex flex-col items-center justify-center text-white p-3 text-center">
            <Lock size={22} className="text-brand-gold" />
            <span className="mt-2 text-xs uppercase tracking-wide">Locked · {TIER_LABEL[item.required_tier]}</span>
            <button
              data-testid={`unlock-${item.id}`}
              onClick={() => navigate(`/packages?tier=${item.required_tier}&checkout=true`)}
              className="mt-3 rounded-full bg-brand-gold hover:bg-brand-golddark px-4 py-1.5 text-xs font-semibold">
              Unlock with {TIER_LABEL[item.required_tier]}
            </button>
          </div>
        ) : (
          <button onClick={() => onOpen(item)} data-testid={`open-${item.id}`}
            className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 bg-black/25 transition-opacity">
            <span className="rounded-full bg-white text-brand-ink p-3 shadow-lg">
              {isVideo ? <Play size={20} /> : <ExternalLink size={20} />}
            </span>
          </button>
        )}
        {completed && !locked && (
          <span className="absolute top-2 right-2 rounded-full bg-brand-sage text-white p-1"><Check size={14} /></span>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <span className="text-[11px] uppercase tracking-wide text-brand-muted">{item.category}</span>
        <h4 className="mt-1 font-medium text-brand-ink text-sm leading-snug line-clamp-2">{item.title}</h4>
        {!locked && (
          <div className="mt-3 flex items-center justify-between">
            <button onClick={() => onOpen(item)} className="text-xs font-semibold text-brand-sage hover:underline">
              {isVideo ? "Watch" : "Open"}
            </button>
            <label className="flex items-center gap-1.5 text-xs text-brand-muted cursor-pointer" data-testid={`complete-toggle-${item.id}`}>
              <input type="checkbox" checked={!!completed} onChange={(e) => onToggle(item.id, e.target.checked)} className="accent-brand-sage" />
              Done
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
